import {useContainer} from "#imports";
import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import {HomeExploreCardModel} from "~~/package/mapper/home/model/HomeExploreCardModel";
import type HomeMapper from "~~/package/mapper/home/HomeMapper";
import type {PageModel} from "~~/package/mapper/common/model/PageModel";
import type {ArticleModel} from "~~/package/mapper/home/model/ArticleModel";

export const useHomeService = () => {
    const homeMapper = useContainer<HomeMapper>(DependencyInjectId.HomeMapper);

    const getArticleList = (page: number, size: number, type: string, lang: string): Promise<PageModel<ArticleModel>> => {
        return homeMapper.getArticleList(page, size, type, lang);
    }

    const getArticle = (params: {id?: number, link?: string}): Promise<ArticleModel> => {
        return homeMapper.getArticle(params);
    }

    return {
        getArticleList,
        getArticle
    };
};
